import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'
const projectName = '/api/blade-platform';

const serviceClassifyType = {
    state: {
        serviceClassifyTypeComponentName: getStore({
            name: 'serviceClassifyTypeComponentName'
        }) || 'basicPage',
    },
    mutations: {
        SET_serviceClassifyTypeComponentName: (state, serviceClassifyTypeComponentName) => {
            state.serviceClassifyTypeComponentName = serviceClassifyTypeComponentName
            setStore({
                name: 'serviceClassifyTypeComponentName',
                content: state.serviceClassifyTypeComponentName,
                type: 'session'
            })
        }
    },
    actions: {
        // 查询服务类型列表
        getServiceTypeList(actions, data) {
            return request({
                url: `${projectName}/serviceType/list`,
                method: 'post',
                data,
            })
        },
        // 新增或者修改服务类型
        getServiceTypeSubmit(actions, data) {
            return request({
                url: `${projectName}/serviceType/submit`,
                method: 'post',
                data,
            })
        },
        // 查询服务类型列表
        getServiceTypeRemove(actions, data) {
            return request({
                url: `${projectName}/serviceType/remove`,
                method: 'post',
                data,
            })
        },
    }
}
export default serviceClassifyType
